
/**
 * the ids of the following users
 * Administrator
 * Jörg Geyer
 * Vilizar Todorov (vilizart@3d-stockpicker.com)
 
 */
export const userIDsWithKPIsChartReadPermissions = [11, 28, 1371586]

/**
 * The ids of the users who's data should be ignored from the stats
 * Administrator
 * Jörg Geyer
 * Alexandar Alikanov (alexandara@3d-stockpicker.com)
 * Vilizar Todorov (vilizart@3d-stockpicker.com)
 * Vilizar Todorov(vilizartodorovkit@gmail.com)
 * Victoria
 */
export const kpisIgnoredUsers = [11, 28, 2495, 1371586, 1734954, 2485]

class PropCfg {

    constructor(propName, label) {
        this.propName = propName
        this.label = label
    }
}

export const StatisticProps = {
    regularUpdates: new PropCfg('regularUpdates', "Regular Updates"),
    mistakesDetectionUpdates: new PropCfg('mistakesDetectionUpdates', "Mistakes Detection Updates"),
    fullReviews: new PropCfg('fullReviews', "Full Reviews"),
    coreDataReviews: new PropCfg('coreDataReviews', "Core Data Reviews"),
    incrementalCoreDataReviews: new PropCfg('incrementalCoreDataReviews', "Incremental Core Data Reviews"),
    visualChecks: new PropCfg('visualChecks', "Visual Checks"),
    totalScore: new PropCfg('totalScore', "Total Score"),
    totalScoreMistakesAdjusted: new PropCfg('totalScoreMistakesAdjusted', "Total Score (Mistakes Adjusted)"),
    actualWorkingHours: new PropCfg('actualWorkingHours', "Actual Working Hours"),
    declaredWorkingHours: new PropCfg('declaredWorkingHours', "Total (Filler + QA) Declared Working Hours"),
    totalScoreToActualWorkingHoursRatio: new PropCfg("totalScoreToActualWorkingHoursRatio", "Total Score / Actual Working Hours"),
    totalScoreToTotalDeclaredWorkingHoursRatio: new PropCfg("totalScoreToTotalDeclaredWorkingHoursRatio", "Total Score / Total Declared Working Hours"),
    actualToDeclaredWorkingHoursRatio: new PropCfg("actualToDeclaredWorkingHoursRatio", "Actual Working Hours / Total Declared Working Hours"),
    qaScoreToDeclaredQaWorkingHoursRatio: new PropCfg("qaScoreToDeclaredQaWorkingHoursRatio", "QA Productivity Score / Declared Working Hours As QA"),
    fillerScoreToDeclaredFillerWorkingHoursRatio: new PropCfg("fillerScoreToDeclaredFillerWorkingHoursRatio", "Filler Productivity Score / Declared Working Hours As Filler"),
    totalClicks: new PropCfg('totalClicks', "Total Clicks"),
    totalKeystrokes: new PropCfg('totalKeystrokes', "Total Keystrokes"),
};

export const All_PROPS = [...Object.values(StatisticProps)]

export const DEFAULT_CART_CFG_OPS = {
    fontSize: 12,
    chartArea: {
        left: 50,
        right: 10,
        top: 10,
        bottom: 45,
    },
    chart: {
        title: '-',
    },
    tooltip: {
        textStyle: {
            fontName: 'verdana',
            fontSize: 11,
        },
    },
    legend: {
        position: 'bottom',
        textStyle: {
            fontSize: 10,
            maxLines: 3,
        },
    },
    vAxis: {
        // scaleType: 'log',
        format: 'short',
    },
    focusTarget: 'category',
    crosshair: { orientation: 'both', trigger: 'focus' },
};

export const INTERVAL_TYPE = {
    WEEKLY: "WEEKLY",
    MONTHLY: "MONTHLY",
};
